import { render, staticRenderFns } from "./sidebar-drawer.vue?vue&type=template&id=6deafc6c&"
import script from "./sidebar-drawer.vue?vue&type=script&lang=js&"
export * from "./sidebar-drawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports